<template>
    <slide-up-modal
        v-if="modalDisplayed"
        ref="voidFormModal"
        modal-id="voidFormModal"
        modal-title="Signature électronique du contrat"
        @modal-closed="hideModal"
    >
        <div v-if="displayGlobalError" 
            class="alert alert-danger" 
            role="alert"
        >
            {{ globalErrorMessage }}
        </div>

        <p>
            Êtes-vous certain de vouloir rendre ce contrat caduc ?
            Cette opération est irréversible.
        </p>

        <div style="margin-top: 20px;">
            <button @click="submit" class="btn btn-primary btn-sm">Valider</button>
            <button @click="hideModal" class="btn btn-default btn-sm">Annuler</button>
        </div>
    </slide-up-modal>
</template>

<script>
    import SlideUpModal from 'components/Modals/SlideUpModal'

    export default {
        data() {
            return {
                modalDisplayed: false,
                displayGlobalError: false,
                globalErrorMessage: null
            }
        },

        props: ['digitalContract'],

        components: {
            SlideUpModal
        },

        methods: {
            displayModal() {
                this.modalDisplayed = true
            },

            hideModal() {
                this.modalDisplayed = false
            },

            displayModalLoader() {
                this.$refs.voidFormModal.isLoading = true
            },

            hideModalLoader() {
                this.$refs.voidFormModal.isLoading = false
            },

            resetAllErrors() {
                this.globalErrorMessage = null
                this.displayGlobalError = false
            },

            submit() {
                this.resetAllErrors()
                this.displayModalLoader()

                this.axios
                    .put(`contracts/${this.digitalContract.contract_id}/digital_contracts/${this.digitalContract.id}/void`)
                    .then(response => {
                        this.$emit('accepted')
                        this.hideModal()
                    })
                    .catch(error => {
                        if (error.hasOwnProperty('response') && error.response.hasOwnProperty('data')) {
                            if (error.response.data.hasOwnProperty('message')) {
                                this.globalErrorMessage = error.response.data.message
                                this.displayGlobalError = true
                                this.hideModalLoader()
                            }
                        }
                    })
            },

            onAccepted() {
                this.$emit('accepted')
            }
        }
    }
</script>


// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/Contracts/DigitalSignature/VoidModal.vue